import PageMeta from "~/components/common/meta";
import { ServiceTickets } from "~/components/staff/service-tickets";

export const ServiceTicketsScreen = () => {
  return (
    <>
      <PageMeta title="Service Tickets | Art Handler" />
      <ServiceTickets />
    </>
  );
};
